import { resolveFields, sheetGeometry } from './couponStudio.mjs';

const imageCache=new Map();
async function imageFromUrl(url){
  if(imageCache.has(url))return imageCache.get(url);
  const promise=new Promise((resolve,reject)=>{const image=new Image();image.onload=()=>resolve(image);image.onerror=()=>reject(new Error('No se pudo cargar una imagen del cupón.'));image.src=url;});
  imageCache.set(url,promise);
  if(imageCache.size>12)imageCache.delete(imageCache.keys().next().value);
  return promise;
}
function wrapLines(ctx,text,maxWidth){
  const paragraphs=text.split(/\n/);const result=[];
  for(const para of paragraphs){
    const words=para.split(/\s+/).filter(Boolean);
    if(!words.length){result.push('');continue;}
    let line='';
    for(const word of words){
      const test=line?line+' '+word:word;
      if(ctx.measureText(test).width<=maxWidth||!line){line=test;continue;}
      result.push(line);line=word;
    }
    result.push(line);
  }
  return result;
}
function drawText(ctx,element,text,W,H){
  const x=element.x*W,y=element.y*H,w=element.w*W,h=element.h*H;
  ctx.save();ctx.beginPath();ctx.rect(x,y,w,h);ctx.clip();
  ctx.fillStyle=element.color||'#1b2630';
  ctx.textBaseline='middle';ctx.textAlign=element.align||'center';
  let fontSize=Math.min(150,(Number(element.fontSize)||25)*W/1000);
  let lines=[];
  for(let attempts=0;attempts<24;attempts++){
    ctx.font=`${element.bold?'700':'400'} ${fontSize}px ${['Arial','Verdana','Georgia','Courier New'].includes(element.fontFamily)?'"'+element.fontFamily+'"':'Arial'}, sans-serif`;
    lines=wrapLines(ctx,String(text||''),w*0.96);
    if(lines.length*fontSize*1.20<=h*.96 && lines.every(line=>ctx.measureText(line).width<=w*.98))break;
    fontSize*=0.92;
  }
  const lineH=fontSize*1.2;
  const textX=element.align==='left'?x+w*.02:element.align==='right'?x+w*.98:x+w/2;
  const startY=y+(h-lines.length*lineH)/2+lineH/2;
  lines.forEach((line,i)=>ctx.fillText(line,textX,startY+i*lineH));
  ctx.restore();
}
function drawContain(ctx,image,x,y,w,h,background,mode='contain'){
  if(background){ctx.fillStyle=background;ctx.fillRect(x,y,w,h);}
  const scale=(mode==='cover'?Math.max:Math.min)(w/image.width,h/image.height);
  const newW=image.width*scale,newH=image.height*scale;
  ctx.save();ctx.beginPath();ctx.rect(x,y,w,h);ctx.clip();ctx.drawImage(image,x+(w-newW)/2,y+(h-newH)/2,newW,newH);ctx.restore();
}
/**
 * Render a single coupon on HTMLCanvasElement. All export modes use this same renderer.
 * Coupon QR encodes ONLY the opaque code, not a customer or a public URL.
 */
export async function renderCoupon(canvas,design,campaign={},coupon={},number=1,qrDataUrl=null,scale=8){
  const {couponWidthMm,couponHeightMm}=sheetGeometry(design.page);
  const W=Math.round(couponWidthMm*scale),H=Math.round(couponHeightMm*scale);
  if(W<60||H<60||W>7000||H>7000)throw new Error('Tamaño de cupón no válido.');
  canvas.width=W;canvas.height=H;
  const ctx=canvas.getContext('2d',{alpha:false});
  ctx.fillStyle=design.canvas.background||'#ffffff';ctx.fillRect(0,0,W,H);
  for(const element of (design.canvas.elements||[])){
    const x=element.x*W,y=element.y*H,w=element.w*W,h=element.h*H;
    if(element.type==='rect'){
      ctx.fillStyle=element.color||'#ffffff';ctx.fillRect(x,y,w,h);
    }else if(element.type==='text'){
      drawText(ctx,element,resolveFields(element.text,{...campaign,terms:design.canvas.terms||campaign.terms},coupon,number),W,H);
    }else if(element.type==='image'&&element.image){
      const img=await imageFromUrl(element.image);drawContain(ctx,img,x,y,w,h,null,element.imageMode||'contain');
    }else if(element.type==='qr'){
      // SVG is not accepted. A PNG from the locally bundled QRCode library is required.
      ctx.fillStyle='#ffffff';ctx.fillRect(x,y,w,h);
      if(qrDataUrl){const img=await imageFromUrl(qrDataUrl);
        ctx.imageSmoothingEnabled=false;drawContain(ctx,img,x,y,w,h,'#ffffff');ctx.imageSmoothingEnabled=true;}
      else {ctx.fillStyle='#5c707a';ctx.font=`${Math.max(12,W*.02)}px Arial`;ctx.textAlign='center';ctx.fillText('QR al emitir',x+w/2,y+h/2);}
    }
  }
  return canvas;
}
